const cloneDeep = require('lodash.cloneDeep');

export class ObjectUtils {

    static cloneDeep = cloneDeep;
    static assign = Object.assign;
}

